import { KeyedLoaded } from "common/loader";
import { ImportResult } from "features/catalogue/types";

export enum TypeKeys {
    FETCH_BEGIN = "IMPORT/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "IMPORT/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "IMPORT/FETCH_EDITABLE_FAILURE",
    RESET_IMPORT = "IMPORT/RESET",
}
export const createAction = {
    loading: () => ({ type: TypeKeys.FETCH_BEGIN }),
    loaded: (data: ImportResult) => ({ type: TypeKeys.FETCH_SUCCESS, data }),
    failed: (error: any) => ({ type: TypeKeys.FETCH_FAILURE, error }),
    resetImport: () => ({ type: TypeKeys.RESET_IMPORT }),
};

type LoadingAction = { type: TypeKeys.FETCH_BEGIN; key: string };
type LoadedAction = { type: TypeKeys.FETCH_SUCCESS; key: string; data: ImportResult };
type FailedAction = { type: TypeKeys.FETCH_FAILURE; key: string; error: any };
type ResetAction = { type: TypeKeys.RESET_IMPORT };

type ImportAction = LoadingAction | LoadedAction | FailedAction | ResetAction;

export type State = KeyedLoaded<ImportResult, string | undefined>;

const initialState: State = {
    status: "unloaded",
};

export function reducer(state: State = initialState, action: ImportAction): State {
    if (action.type === TypeKeys.FETCH_BEGIN) {
        return {
            status: "loading",
            key: action.key,
        };
    }

    if (action.type === TypeKeys.FETCH_SUCCESS) {
        const { data, key } = action;

        return {
            status: "loaded",
            key,
            data,
        };
    }

    if (action.type === TypeKeys.FETCH_FAILURE) {
        const { error, key } = action;

        return {
            status: "failed",
            key,
            error,
        };
    }

    if (action.type === TypeKeys.RESET_IMPORT) {
        return initialState;
    }

    return state;
}
